import { useState, useRef, useEffect } from 'react';
import '../housestyle.css';
import './Home.css';
import api from '../API/Api';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/Animations';
import { McIcon } from '../components/CraftingGrid';
import DiscordMarkdown from '../components/DiscordMarkdown';


function IPBar() {
  const [toastVisible, setToastVisible] = useState(false);
  const timerRef = useRef(null);

  function copyIP() {
    navigator.clipboard.writeText('play.simplemcnetwork.net').catch(() => { });
    setToastVisible(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setToastVisible(false), 1800);
  }

  return (
    <>
      <div className="home-ip-bar">
        <div className="home-ip-item">
          <span className="home-ip-label">IP</span>
          <span className="home-ip-value">play.simplemcnetwork.net</span>
          <button className="home-ip-copy" onClick={copyIP}>Copy</button>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Version</span>
          <span className="home-ip-value">1.21+</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Status</span>
          <span className="home-ip-value home-ip-value--development">● in development</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Mode</span>
          <span className="home-ip-value" style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Java</span>
        </div>

        <div className="home-ip-divider" />

        <div className="home-ip-item">
          <span className="home-ip-label">Support cracked?</span>
          <span className="home-ip-value" style={{ color: 'var(--text-primary)', fontWeight: 600 }}>Yes</span>
        </div>
      </div>

      <div className={`home-copied-toast${toastVisible ? ' show' : ''}`}>
        IP Copied!
      </div>
    </>
  );
}

function StatCard({ icon, value, label }) {
  return (
    <div className="home-stat-card">
      <McIcon materialKey={icon} size={28} />
      <div>
        <div className="home-stat-val">{value}</div>
        <div className="home-stat-lbl">{label}</div>
      </div>
    </div>
  );
}

function FeatureCard({ material, title, desc, barClass }) {
  return (
    <div className="home-feat-card">
      <div className={`home-feat-bar ${barClass}`} />
      <McIcon materialKey={material} size={32} />
      <h3>{title}</h3>
      <p>{desc}</p>
    </div>
  );
}

function Step({ num, title, children }) {
  return (
    <div className="home-step">
      <div className="home-step-num">{num}</div>
      <h4>{title}</h4>
      <p>{children}</p>
    </div>
  );
}

function NewsCard({ item }) {
  const isOffer = item.type === 'offer';
  return (
    <div className={`home-news-card ${isOffer ? 'home-news-card--offer' : ''} ${item.image_url ? 'home-news-card--has-img' : ''}`}>
      <div className="home-news-content">
        <div className="home-news-header">
          <span className={`home-news-badge ${item.type}`}>
            {isOffer ? 'Limited Offer' : item.type}
          </span>
          <span className="home-news-date">
            {new Date(item.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}
          </span>
        </div>
        <h3>{item.title}</h3>
        <DiscordMarkdown text={item.content} className="home-news-body" />
        <div className="home-news-footer">
          <span className="home-news-author">By {item.author || 'Staff'}</span>
        </div>
      </div>
      {item.image_url && (
        <div className="home-news-img">
          <img src={item.image_url} alt={item.title} />
        </div>
      )}
    </div>
  );
}

const serverinfo = [
  { material: 'IRON_INGOT', value: 'Season 1', label: 'Current Season' },
  { material: 'MAP', value: '10K x 10K', label: 'EXPANDABLE World Border' },
  { material: 'DIAMOND_SWORD', value: 'Custom', label: 'Weapons & Mobs and Recipes' },
  { material: 'GOLD_NUGGET', value: 'Daily / Weekly', label: 'Events & Supply Drops' },
];

const features = [
  {
    material: 'DIAMOND_SWORD',
    title: 'Custom Weapons',
    desc: 'New weapons, armour, tools and other items - crafted in-game with new drops from various sources.',
    barClass: 'home-feat-bar--red',
  },
  {
    material: 'REDSTONE',
    title: 'Custom Mobs',
    desc: "Unique bosses and mob variants with tiered drops. Explore the world and find what's lurking.",
    barClass: 'home-feat-bar--blue',
  },
  {
    material: 'CHEST_MINECART',
    title: 'Supply Drops',
    desc: 'Random supply crates scattered across the map. Loot them before someone else does.',
    barClass: 'home-feat-bar--green',
  },
  {
    material: 'FIREWORK_ROCKET',
    title: 'Events',
    desc: 'Regular seasonal events and competitions with exclusive rewards and community engagement.',
    barClass: 'home-feat-bar--gold',
  },
  {
    material: 'GOLD_INGOT',
    title: 'Fun Community',
    desc: 'Active player base with regular polls, staff interaction, and a welcoming environment for all.',
    barClass: 'home-feat-bar--purple',
  },
  {
    material: 'OAK_PLANKS',
    title: 'Good Anticheat',
    desc: 'Advanced cheat detection keeps the playing field fair for everyone.',
    barClass: 'home-feat-bar--blue',
  },
  {
    material: 'OMINOUS_TRIAL_KEY',
    title: 'Cracked Supported',
    desc: 'Play with or without a premium Minecraft account. Everyone welcome.',
    barClass: 'home-feat-bar--green',
  },
  {
    material: 'MAP',
    title: 'New POIs',
    desc: 'Explore unique locations with interesting stories and challenges.',
    barClass: 'home-feat-bar--gold',
  }
];

export default function HomePage() {
  const [visits, setVisits] = useState(null);
  const [news, setNews] = useState([]);

  useEffect(() => {
    api('trackvisit').then(res => {
      if (res.isSuccess) setVisits(res.data?.visits ?? null);
    });
    api('getnews').then(res => {
      if (res.isSuccess) setNews(res.data || []);
    });
  }, []);
  return (
    <div style={{ paddingBottom: '4rem' }}>

      <div className="home-hero">
        <video autoPlay muted loop playsInline src='https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/Trailer.mp4'>
        </video>
        <div className="home-hero-overlay" />
        <div className="home-hero-logo">
          <FadeIn y={30} duration={0.8}>
            <div className="home-hero-logo-text">
              Simple<em>MC</em>
            </div>
            <div className="home-hero-logo-sub">Season 1 | Survival SMP</div>
            <div className="home-hero-logo-text-medium">IN DEVELOPMENT</div>
          </FadeIn>
        </div>
        <div className="home-hero-video-label">Website Visits: {visits}</div>
      </div>

      <IPBar />

      <div className="container" style={{ paddingTop: '3.5rem' }}>
        <StaggerContainer className="home-about-grid">
          <StaggerItem className="home-about-main">
            <div className="home-eyebrow">Season 1</div>
            <h2>A Survival SMP <span>completely reinvented.</span></h2>
            <p>
              Experience Minecraft like never before. Face entirely new mobs, discover custom biomes,
              and encounter bosses that will change how you play. Every corner of the map holds surprises
              brand new creatures, mechanics, and challenges await. Build, compete, and survive in a world
              designed to deliver a fresh adventure beyond vanilla Minecraft.
            </p>
            <div className="home-about-btns">
              <button className="btn btn-primary">Join Now</button>
              <button className="btn btn-secondary"
                onClick={() => window.open('https://discord.com/invite/simplemc', '_blank')}>
                Discord
              </button>
            </div>
          </StaggerItem>

          <StaggerContainer className="home-stat-stack">
            {serverinfo.map((s, i) => (
              <StaggerItem key={i}>
                <StatCard icon={s.material} value={s.value} label={s.label} />
              </StaggerItem>
            ))}
          </StaggerContainer>
        </StaggerContainer>

        <FadeIn duration={0.8}>
          <div className="section-label" style={{ marginTop: '3rem', marginBottom: '1.5rem' }}>
            <span className="sl-text">Latest News & Offers</span>
          </div>
          {news.length > 0 ? (
            <div className="home-news-grid">
              {news.slice(0, 3).map((item, i) => (
                <NewsCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <div className="home-news-empty">
              <p>No news or offers at the moment. Check back soon!</p>
            </div>
          )}
        </FadeIn>

        <div className="section-label" style={{ marginBottom: '1.25rem' }}>
          <span className="sl-text">New Experience</span>
        </div>

        <StaggerContainer className="home-features-grid">
          {features.map((f, i) => (
            <StaggerItem key={i}>
              <FeatureCard
                material={f.material}
                title={f.title}
                desc={f.desc}
                barClass={f.barClass}
              />
            </StaggerItem>
          ))}
        </StaggerContainer>

        <div className="section-label" style={{ marginBottom: '1.25rem' }}>
          <span className="sl-text">How to join</span>
        </div>

        <div className="home-join-card">
          <StaggerContainer className="home-steps">
            <StaggerItem>
              <Step num="1" title="Open Minecraft">
                Launch Java Edition 1.21+ or higher on your PC.
              </Step>
            </StaggerItem>
            <StaggerItem>
              <Step num="2" title="Add Server">
                Go to Multiplayer → Add Server and give it a name.
              </Step>
            </StaggerItem>
            <StaggerItem>
              <Step num="3" title="Enter IP">
                Server address:{' '}
                <span className="home-step-ip">play.simplemcnetwork.net</span>
              </Step>
            </StaggerItem>
            <StaggerItem>
              <Step num="4" title="Join & Play">
                Hit connect and spawn in. Prepare for the unexpected.
              </Step>
            </StaggerItem>
          </StaggerContainer>
        </div>
      </div>
    </div>
  );
}